import { render, staticRenderFns } from "./mktLabel.vue?vue&type=template&id=1a562d88&"
import script from "./mktLabel.vue?vue&type=script&lang=js&"
export * from "./mktLabel.vue?vue&type=script&lang=js&"
import style0 from "./mktLabel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports